module.exports = __webpack_public_path__ + "static/media/rightarrow1.af64a1f4.svg";